import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import api from "../../services/api";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import SearchInput from "../../components/common/SearchInput";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import MessageDialog from "../../components/common/MessageDialog";
import moment from "moment";
import { useMenuAuthInfo, useMultiLang } from "../../services/GlobalUtil";

const UserManagementDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const menuAuthInfo = useMenuAuthInfo();

  const cId = location.state.id;

  const [data, setData] = useState("");

  const [language, setLanguage] = useState("");
  const [useYn, setUseYn] = useState("");
  const [auth, setAuth] = useState("");
  const [authDesc, setAuthDesc] = useState("");
  const [menuAuth, setMenuAuth] = useState("");
  const [logActive, setLogActive] = useState("");

  const sbLanguage = [...useMultiLang("LANG")];
  const sbUseYn = [
    { codeDesc: "YES", code: "Y" },
    { codeDesc: "NO", code: "N" },
  ];
  const sbMenuAuth = [
    { code: "MNG", codeDesc: t("L0440") },
    { code: "INSP", codeDesc: t("L0156") },
  ];
  const sbLogActive = [
    { codeDesc: "YES", code: "Y" },
    { codeDesc: "NO", code: "N" },
  ];

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    loadContentData();
  }, []);

  const loadContentData = () => {
    api
      .post("/manage/user/detail", {
        id: cId,
      })
      .then((response) => {
        setData(response.data);
        setLanguage(response.data.language);
        setUseYn(response.data.useYn);
        setAuth(response.data.auth);
        setAuthDesc(response.data.authDesc);
        setMenuAuth(response.data.menuAuth === "INSP" ? "INSP" : "MNG");
        setLogActive(response.data.logActive);
      })
      .catch(() => {});
  };

  const handleInitializePw = (userId) => {
    api
      .post("/manage/user/initial-pw", {
        userId: userId,
      })
      .then(() => {
        setIsDialogOpen(true);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    navigate("/manage/user");
  };

  const handleSubmit = () => {
    if (!cId || !language || !useYn || !menuAuth || !logActive) {
      alert("Please enter all required fields.");
      return;
    }

    api
      .post("/manage/user/update", {
        id: cId,
        language: language,
        useYn: useYn,
        auth: auth,
        menuAuth: menuAuth,
        logActive: logActive,
      })
      .then(() => {
        setIsDialogOpen(true);
      })
      .catch(() => {});
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
    navigate("/manage/user");
  };

  return (
    <div>
      <BreadCrumbDiv
        items={[t("MENU:L0056"), t("MENU:L0072"), t("L0097")]}
      ></BreadCrumbDiv>

      <ListWrapDiv className={"list_hori"}>
        <table>
          <colgroup>
            <col style={{ width: "20%" }} />
            <col style={{ width: "30%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "30%" }} />
          </colgroup>
          <tbody>
            <tr>
              <th>{t("L0661")}</th>
              <td colSpan={3}>
                <label>{t(`LOC:${data.location}`)}</label>
              </td>
            </tr>
            <tr>
              <th>{t("L0048")}</th>
              <td>
                <label>{t(`AREA:${data.area}`)}</label>
              </td>
              <th>{t("L0049")}</th>
              <td>
                <label>{t(`UNITED:${data.united}`)}</label>
              </td>
            </tr>
            <tr>
              <th>{t("L0050")}</th>
              <td>
                <label>{t(`CNTRY:${data.country}`)}</label>
              </td>
              <th>{t("L0051")}</th>
              <td>
                <label>
                  {data.locDesc} ( {data.loc} )
                </label>
              </td>
            </tr>
            <tr>
              <th>{t("L0185")}</th>
              <td>
                <label>{data.userId}</label>
              </td>
              <th>{t("L0003")}</th>
              <td>
                <label>{data.eml}</label>
              </td>
            </tr>
            <tr>
              <th>{t("L0657")}</th>
              <td>
                <CodeSelectBox
                  value={language}
                  codes={sbLanguage}
                  onChange={(event) => setLanguage(event.target.value)}
                  width="100%"
                  style={{ border: "0.5px solid lightgray" }}
                  disabled={!menuAuthInfo.edit}
                ></CodeSelectBox>
              </td>
              <th>{t("L0663")}</th>
              <td>
                <label>
                  <CodeSelectBox
                    value={useYn}
                    codes={sbUseYn}
                    onChange={(event) => setUseYn(event.target.value)}
                    width="100%"
                    style={{ border: "0.5px solid lightgray" }}
                    disabled={!menuAuthInfo.edit}
                  ></CodeSelectBox>
                </label>
              </td>
            </tr>
            <tr>
              <th>{t("L0107")}</th>
              <td>
                <SearchInput
                  width="100%"
                  value={t(`AUTH:${data.auth}`)}
                  style={{ border: "0.5px solid lightgray" }}
                  disabled
                ></SearchInput>
              </td>
              <th>{t("L0392")}</th>
              <td>
                <CodeSelectBox
                  value={menuAuth}
                  codes={sbMenuAuth}
                  onChange={(event) => setMenuAuth(event.target.value)}
                  width="100%"
                  style={{ border: "0.5px solid lightgray" }}
                  disabled={!menuAuthInfo.edit}
                ></CodeSelectBox>
              </td>
            </tr>
            <tr>
              <th>{t("L0109")}</th>
              <td>
                <label>
                  {data.pwErrLockDT ? moment(data.pwErrLockDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                </label>
              </td>
              <th>{t("L0110")}</th>
              <td>
                <label>
                  {data.pwAltrDT ? moment(data.pwAltrDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                </label>
              </td>
            </tr>
            <tr>
              <th>{t("L0104")}</th>
              <td>
                <label>
                  {data.createDT ? moment(data.createDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                </label>
              </td>
              <th>{t("L0111")}</th>
              <td>
                <label>
                  {data.updateDT ? moment(data.updateDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                </label>
              </td>
            </tr>
            <tr>
              <th>{t("L0108")}</th>
              <td>
                <label>
                  {data.rctLoginDT ? moment(data.rctLoginDT).format("YYYY-MM-DD HH:mm:ss") : ""}
                </label>
              </td>
              <th>Log Active</th>

              <td>
                {JSON.parse(sessionStorage.getItem("userInfo")).menuAuth ===
                  "HQ_MNG" && (
                  <CodeSelectBox
                    value={logActive}
                    codes={sbLogActive}
                    onChange={(event) => setLogActive(event.target.value)}
                    width="100%"
                    style={{ border: "0.5px solid lightgray" }}
                    disabled={!menuAuthInfo.edit}
                  ></CodeSelectBox>
                )}
              </td>
            </tr>
            <tr>
              <th>{t("L0377")}</th>
              <td colSpan={3}>
                {JSON.parse(sessionStorage.getItem("userInfo")).menuAuth ===
                  "BRANCH_MNG" && (
                  <FunctionButton
                    value={t("L0377")}
                    onClick={() => handleInitializePw(data.userId)}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </ListWrapDiv>
      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        ></FunctionButton>
        {menuAuthInfo.edit && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        )}
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0103")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default UserManagementDetailPage;
